<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-6">
      <label for=""></label>
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-12 col-md-3">
      <div [formGroup]="formularioFiltroTipoDeVendedores" novalidate class="form-group">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" [label]="'Tipo de Vendedor *'" formControlName="idTipoVendedor"
          [control]="formularioFiltroTipoDeVendedores.get('idTipoVendedor')" [id]="'idTipoVendedor'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <div class="form-group col-md-3" style="display: flex;align-items: center;">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>

  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Fecha de Registro'" [label]="'Fecha de Registro *'" [id]="'fechaRegistro'" formControlName="fechaRegistro"
          [control]="formulario.get('fechaRegistro')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Usuario'" [label]="'Usuario *'" [id]="'usuario'"
          formControlName="usuario" [control]="formulario.get('usuario')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores2" formControlName="tipoVendedorId"
          [control]="formulario.get('tipoVendedorId')" [label]="'Tipo de Vendedor *'" [id]="'tipoVendedorId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-8">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombreVendedor1'" [idOpcion]="'codigoSap'"
          [comboBox]="listVendedores" formControlName="vendedorPrincipalCodSap" [control]="formulario.get('vendedorPrincipalCodSap')"
          [label]="'Vendedor *'" [id]="'vendedorPrincipalCodSap'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Vendedor Relacionado'" [label]="'Vendedor Relacionado *'" [id]="'vendedorRelacionadoCodSap'"
          formControlName="vendedorRelacionadoCodSap" [control]="formulario.get('vendedorRelacionadoCodSap')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-8">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Vendedor Relacionado'" [label]="'Vendedor Relacionado *'" [id]="'vendedorRelacionadoNombre'"
          formControlName="vendedorRelacionadoNombre" [control]="formulario.get('vendedorRelacionadoNombre')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Ingrese Fecha Inicio'"
          [label]="'Fecha Inicio *'" [id]="'fechaInicio'" formControlName="fechaInicio"
          [control]="formulario.get('fechaInicio')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Ingrese Fecha Fin'"
          [label]="'Fecha Fin *'" [id]="'fechaFin'" formControlName="fechaFin"
          [control]="formulario.get('fechaFin')"></app-lfsa-input>
      </div>
    </div>
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </div>

</ng-template>

<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Editar Alta de Vendedor'" [idButton]="'buttonAbrirModal'"
  [idOpen]="'abrirModal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese ID'"
          [label]="'ID *'" [id]="'idVendedorRelacionado'" formControlName="idVendedorRelacionado"
          [control]="formulario.get('idVendedorRelacionado')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Fecha de Registro'" [label]="'Fecha de Registro *'" [id]="'fechaRegistro'" formControlName="fechaRegistro"
          [control]="formulario.get('fechaRegistro')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Usuario'" [label]="'Usuario *'" [id]="'usuario'"
          formControlName="usuario" [control]="formulario.get('usuario')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores2" formControlName="tipoVendedorId"
          [control]="formulario.get('tipoVendedorId')" [label]="'Tipo de Vendedor *'" [id]="'tipoVendedorId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-8">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombreVendedor1'" [idOpcion]="'codigoSap'"
          [comboBox]="listVendedores" formControlName="vendedorPrincipalCodSap" [control]="formulario.get('vendedorPrincipalCodSap')"
          [label]="'Vendedor *'" [id]="'vendedorPrincipalCodSap'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Vendedor Relacionado'" [label]="'Vendedor Relacionado *'" [id]="'vendedorRelacionadoCodSap'"
          formControlName="vendedorRelacionadoCodSap" [control]="formulario.get('vendedorRelacionadoCodSap')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-8">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Vendedor Relacionado'" [label]="'Vendedor Relacionado *'" [id]="'vendedorRelacionadoNombre'"
          formControlName="vendedorRelacionadoNombre" [control]="formulario.get('vendedorRelacionadoNombre')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Ingrese Fecha Inicio'"
          [label]="'Fecha Inicio *'" [id]="'fechaInicio'" formControlName="fechaInicio"
          [control]="formulario.get('fechaInicio')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Ingrese Fecha Fin'"
          [label]="'Fecha Fin *'" [id]="'fechaFin'" formControlName="fechaFin"
          [control]="formulario.get('fechaFin')"></app-lfsa-input>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12 col-md-4"></div>
    <div class="form-group col-12 col-md-4">
      <button class="btn btn-success btn-block" [disabled]="formulario.invalid" (click)="actualizar()">
        <i class="fa fa-save"></i>
        Guardar</button>
    </div>
    <div class="form-group col-12 col-md-4"></div>
  </div>
</ng-template>